import { useEffect } from "react";
import UniBtn, { UniBtnPack } from "./UniBtn";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import { _zzyourmap_extract_editorjs_renderable_data } from "../utils/zz/zz-yourmap-blog-post-utils";
import { yourmapNavMaker, _zzyourmap_routing_browser_title_update, _zzyourmap_routing_routeState_to_path, _zzyourmap_routing_static_pages_keys, _zzyourmap_routing_tab_keys } from "../utils/zz/zz-yourmap-routing";
import { _zzyourmap_config } from "../utils/zz/zz-yourmap-config";
import { rapidozi_contact_utils } from "../utils/frfr-rapidozi-contact-utils";
import UniPair from "./UniPair";
import UniLink from "./UniLink";
import YourmapSlider from "./YourmapSlider";
import { MdOutlinePool } from "react-icons/md";
import { TbMassage } from "react-icons/tb";
import { TbParking } from "react-icons/tb";
import { GiHomeGarage } from "react-icons/gi";
import { IoFastFoodOutline } from "react-icons/io5";
import { FaWifi } from "react-icons/fa";
import { MdOutlineVilla } from "react-icons/md";
import { MdOutlineApartment } from "react-icons/md";
import { LuHotel } from "react-icons/lu";
import FrfrAlienGoogleMapsIframeBySrc from "./FrfrAlienGoogleMapsIframeBySrc";

// --- Content helpers ---

const hasText = (value) =>
  typeof value === 'string' && value.trim().length > 0;

const hasItems = (arr) =>
  Array.isArray(arr) && arr.length > 0;

const formatInstagramHandle = (value) => {
  if (!hasText(value)) {
    return '';
  }

  const raw = String(value).trim();

  // If user already entered @handle, keep it normalized.
  if (raw.startsWith('@')) {
    const cleaned = raw.slice(1).split(/[/?#]/)[0].trim();
    return cleaned ? '@' + cleaned : raw;
  }

  // If user entered full URL (or domain/path), extract the first path segment.
  const normalized = raw.includes('://') ? raw : 'https://' + raw;
  try {
    const parsed = new URL(normalized);
    const hostname = (parsed.hostname || '').toLowerCase();
    if (hostname.includes('instagram.com')) {
      const firstPath = parsed.pathname
        .split('/')
        .filter(Boolean)[0] || '';
      if (firstPath.length > 0) {
        return '@' + firstPath;
      }
    }
  } catch (err) {
    // Fall through to plain-text handling below.
  }

  // Fallback for plain nickname or non-standard input.
  const cleaned = raw.split(/[/?#]/)[0].trim();
  return cleaned ? '@' + cleaned.replace(/^@+/, '') : raw;
};

// --- DEFAULT COMPONENT ---
const YourmapSectionSmestajStuff = (props) => {
  const {
    current_smestaj_entity,
    current_restoran_entity, // TODO
  } = props.appPack;
  const item = current_smestaj_entity;
  const title = item.smestaj_naslov;
  _zzyourmap_routing_browser_title_update(title);

  // const img_url_full = _zzyourmap_extract_smestaj_main_img_url(item);
  const img_url_full = item._main_img_url;
  const slide_img_src_arr = item._slide_img_src_arr;
  const detail_gallery_img_src_arr = Array.isArray(slide_img_src_arr)
    ? (slide_img_src_arr.length > 1 ? slide_img_src_arr.slice(1) : slide_img_src_arr)
    : [];

  // --- Section content flags ---

  const hasDescription =
    hasText(item.smestaj_opis) || hasText(item.smestaj_adresa);

  const AMENITY_KEYS = [
    'check_hotel', 'check_apartman', 'check_vila', 'check_bazen',
    'check_spa', 'check_parking', 'check_garaza', 'check_dorucak',
    'check_wifi', 'check_klima',
  ];
  const hasAmenities = AMENITY_KEYS.some((key) => item[key] === true);

  const CONTACT_KEYS = [
    'telefon', 'telefon2', 'mobilni', 'mobilni2',
    'email', 'email2', 'websajt', 'kontakt_instagram_url',
  ];
  const hasContacts = CONTACT_KEYS.some((key) => hasText(item[key]));

  const hasLocation =
    hasText(item.google_maps_iframe_src) || hasContacts;

  // console.log('smestaj geo_uri', item.geo_uri);

  return (
    <>
      {/*
      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-05rem"></div>
          <div className="yourmap__card yourmap__card--big-cover">
            <div className="yourmap__card__overlay-1" style={style}></div>
            <div className="yourmap__card__overlay-2"></div>
            <div className="yourmap__card-destinacija-content">
              <div className="yourmap__article__title-and-subtitle">
                <div className="uu-gap-standalone-1rem"></div>
                <h1>{item.smestaj_naslov}</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-8px"></div>
          <div className="yourmap__slider__thumbnails">
            <div className="uu-vector uu-vector-row uu-vector--forced uu-gaps-p-025rem">
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      */}

      <YourmapSlider
        hero_title={item.smestaj_naslov}
        main_img_src={img_url_full}
        slide_img_src_arr={detail_gallery_img_src_arr}
        showHeroTitle={false}
      />

      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-16px"></div>
          <div className="yourmap__card yourmap__card--normal uu-shadow-alien-fluent2-tile-shadow">
            <h2>{item.smestaj_naslov}</h2>
            <p>{item.smestaj_podnaslov}</p>
          </div>
        </div>
      </section>

      {hasDescription && (
        <section className="yourmap__section">
          <div className="inner">
            <div className="uu-gap-standalone-16px"></div>
            <div className="yourmap__card yourmap__card--normal yourmap__card--location uu-shadow-alien-fluent2-tile-shadow">
              <h3>Opis</h3>
              {hasText(item.smestaj_opis) && (
                <p className="uu-text-justify">{item.smestaj_opis}</p>
              )}
              {hasText(item.smestaj_adresa) && (
                <>
                  <div className="uu-gap-standalone-8px"></div>
                  <p><i className="fa fa-map-marker" aria-hidden="true"></i>&nbsp;&nbsp;{item.smestaj_adresa}</p>
                </>
              )}
            </div>
          </div>
        </section>
      )}

      {hasAmenities && (
        <section className="yourmap__section">
          <div className="inner">
            <div className="uu-gap-standalone-1rem"></div>
            <h3 className="yourmap__heading-above-card">Pogodnosti</h3>
            <div className="yourmap__grid yourmap__grid--items-w-1-5">
              {item.check_hotel === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><LuHotel /></div>}
                      jsx2={<span>Hotel</span>}
                    />
                  </div>
                </div>
              )}
              {item.check_apartman === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><MdOutlineApartment /></div>}
                      jsx2={<span>Apartman</span>}
                    />
                  </div>
                </div>
              )}
              {item.check_vila === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><MdOutlineVilla /></div>}
                      jsx2={<span>Vila</span>}
                    />
                  </div>
                </div>
              )}
              {item.check_bazen === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><MdOutlinePool /></div>}
                      jsx2={<span>Bazen</span>}
                    />
                  </div>
                </div>
              )}
              {item.check_spa === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><TbMassage /></div>}
                      jsx2={<span>Spa centar</span>}
                    />
                  </div>
                </div>
              )}
              {item.check_parking === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    {/*<div className="yourmap__card__pogodnost__icon"><i className="fa fa-car" aria-hidden="true"></i></div>*/}
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><TbParking /></div>}
                      jsx2={<span>Parking</span>}
                    />
                  </div>
                </div>
              )}
              {item.check_garaza === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><GiHomeGarage /></div>}
                      jsx2={<span>Garaža</span>}
                    />
                  </div>
                </div>
              )}
              {item.check_dorucak === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><IoFastFoodOutline /></div>}
                      jsx2={<span>Doručak</span>}
                    />
                  </div>
                </div>
              )}
              {item.check_wifi === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    {/*<div className="yourmap__card__pogodnost__icon"><i className="fa fa-wifi" aria-hidden="true"></i></div>*/}
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><FaWifi /></div>}
                      jsx2={<span>WiFi</span>}
                    />
                  </div>
                </div>
              )}
              {item.check_klima === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <div className="yourmap__card__pogodnost__icon"><i className="fa fa-snowflake-o" aria-hidden="true"></i></div>
                    <span>Klima</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      )}

      {hasLocation && (
        <section className="yourmap__section">
          <div className="inner">
            <div className="uu-gap-standalone-1rem"></div>
            <h3 className="yourmap__heading-above-card">Lokacija</h3>
            <div className="yourmap__card yourmap__card--normal uu-shadow-alien-fluent2-tile-shadow">

              <div className="yourmap__pair-map-and-contact">
                {hasText(item.google_maps_iframe_src) && (
                  <div className="yourmap__pair-map-and-contact__map">
                    <FrfrAlienGoogleMapsIframeBySrc
                      src={item.google_maps_iframe_src}
                      width="600"
                      height="240"
                    />
                  </div>
                )}
                {hasContacts && (
                  <>
                    <div className="uu-gap-standalone-16px yourmap__pair-map-and-contact__mobile-gap"></div>
                    <div className="yourmap__pair-map-and-contact__contact contact-items">
                      {hasText(item.telefon) && (
                        <UniPair
                          iconAndTitle
                          extraClass="yourmap__theme__contact-pair"
                          jsx1={<div className="yourmap__contact__icon"><i className="fa fa-phone" aria-hidden="true"></i></div>}
                          jsx2={<UniLink
                            phone={rapidozi_contact_utils.fix_contact_phone_number(item.telefon)}
                          ><span>{item.telefon}</span></UniLink>}
                        />
                      )}
                      {hasText(item.telefon2) && (
                        <UniPair
                          iconAndTitle
                          extraClass="yourmap__theme__contact-pair"
                          jsx1={<div className="yourmap__contact__icon"><i className="fa fa-phone" aria-hidden="true"></i></div>}
                          jsx2={<UniLink
                            phone={rapidozi_contact_utils.fix_contact_phone_number(item.telefon2)}
                          ><span>{item.telefon2}</span></UniLink>}
                        />
                      )}
                      {hasText(item.mobilni) && (
                        <UniPair
                          iconAndTitle
                          extraClass="yourmap__theme__contact-pair"
                          jsx1={<div className="yourmap__contact__icon"><i className="fa fa-mobile" aria-hidden="true"></i></div>}
                          jsx2={<UniLink
                            phone={rapidozi_contact_utils.fix_contact_phone_number(item.mobilni)}
                          ><span>{item.mobilni}</span></UniLink>}
                        />
                      )}
                      {hasText(item.mobilni2) && (
                        <UniPair
                          iconAndTitle
                          extraClass="yourmap__theme__contact-pair"
                          jsx1={<div className="yourmap__contact__icon"><i className="fa fa-mobile" aria-hidden="true"></i></div>}
                          jsx2={<UniLink
                            phone={rapidozi_contact_utils.fix_contact_phone_number(item.mobilni2)}
                          ><span>{item.mobilni2}</span></UniLink>}
                        />
                      )}
                      {hasText(item.email) && (
                        <UniPair
                          iconAndTitle
                          extraClass="yourmap__theme__contact-pair"
                          jsx1={<div className="yourmap__contact__icon"><i className="fa fa-envelope-o" aria-hidden="true"></i></div>}
                          jsx2={<UniLink
                            email={item.email}
                          ><span>{item.email}</span></UniLink>}
                        />
                      )}
                      {hasText(item.email2) && (
                        <UniPair
                          iconAndTitle
                          extraClass="yourmap__theme__contact-pair"
                          jsx1={<div className="yourmap__contact__icon"><i className="fa fa-envelope-o" aria-hidden="true"></i></div>}
                          jsx2={<UniLink
                            email={item.email2}
                          ><span>{item.email2}</span></UniLink>}
                        />
                      )}
                      {hasText(item.websajt) && (
                        <UniPair
                          iconAndTitle
                          extraClass="yourmap__theme__contact-pair"
                          jsx1={<div className="yourmap__contact__icon"><i className="fa fa-link" aria-hidden="true"></i></div>}
                          jsx2={<UniLink
                            targetBlank
                            href={rapidozi_contact_utils.fix_contact_website_url(item.websajt)}
                          ><span>{item.websajt}</span></UniLink>}
                        />
                      )}
                      {hasText(item.kontakt_instagram_url) && (
                        <UniPair
                          iconAndTitle
                          extraClass="yourmap__theme__contact-pair"
                          jsx1={<div className="yourmap__contact__icon"><i className="fa fa-instagram" aria-hidden="true"></i></div>}
                          jsx2={<UniLink
                            targetBlank
                            href={rapidozi_contact_utils.fix_contact_website_url(item.kontakt_instagram_url)}
                          ><span>{formatInstagramHandle(item.kontakt_instagram_url)}</span></UniLink>}
                        />
                      )}
                    </div>
                  </>
                )}
              </div>

            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default YourmapSectionSmestajStuff;